require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.9@core-js/library/modules/es7.symbol.observable.js
// module id = 74
// module chunks = 0